import { create } from '@storybook/theming';

export default create({
  base: 'light',
  colorPrimary: 'white',
  colorSecondary: '#EC6D75',
  appBg: 'white',
  appContentBg: 'white',
  appBorderColor: 'white',
  appBorderRadius: 4,
  fontBase: 'Lato, Helvetica, sans-serif',
  fontCode: 'Lato, Helvetica, sans-serif',
  textColor: '#45365a',
  textInverseColor: '#5c4c73',
  barTextColor: '#45365a',
  barSelectedColor: '#ec6d75',
  barBg: 'linear-gradient(0deg, #FCFBF8 0%, #F7F3EE 100.74%)',
  inputBg: 'black',
  inputBorder: '#e6e6e6',
  inputTextColor: '#45365a',
  inputBorderRadius: 4,
  brandTitle: 'Ambush',
  brandImage: require('./assests/logoRed.svg'),
  brandImageAlt: 'Ambush Logo',
  brandUrl: './',
});
